import type { z } from 'zod';

import type { WorkflowListParamsSchema } from '../models/workflow';

const FEATURE_NAME = 'workflow';

export const queryKeyMap = {
  workflowList: (params?: z.infer<typeof WorkflowListParamsSchema>) =>
    [FEATURE_NAME, 'list', params].filter((item) => item !== undefined),
  workflow: (id: string) => [FEATURE_NAME, id],
  templates: () => [FEATURE_NAME, 'template', 'list'],
  template: (id: string) => [FEATURE_NAME, 'template', id],
};
